
// setTimeout(function(){
//   $('form[data-id=39811]').submit(function(){
//     var params = {
//       vision_insurance: $('select[name=select] option:selected').val(),
//       dob: $('#datetime').val(),
//       member_id: $('form[data-id=39811] input[name=text]').val(),
//       email_or_zoom: $('select[name=select-2] option:selected').val(),
//       email: $('input[name=email-2]').val(),
//       zoom: $('#datetime-2').val(),
//       add_prescription: $('input[name=radio]:checked').val(),
//       lens: $('select[name=select-3] option:selected').val(),
//       previously_visited_stores: $('select[name=select-4] option:selected').val(),
//       send_prescription: $('select[name=select-5] option:selected').val(),
//     };
// //     addInsuranceProduct(params)
//   });
// }, 3000);

// function addInsuranceProduct (params)
// {
//   var insurance_id = $('.insurance-product-id').text();
//   var product_title = $('#for-insurance-product').text();
//   var pro_color = $('.id-product-select-option-0 span .value').text();
//   $.ajax({
//     url: '/cart/add.js',
//     type: 'post',
//     dataType: 'json',
//     async: false,
//     data: {
//       id: insurance_id,
//       quantity: 1,
//       properties: {
//         'Product Title': product_title,
//         'Vision Insurance': params.vision_insurance,
//         'Date of Birth': params.dob,
//         'Member Id': params.member_id,
//         'Email OR Zoom': params.email_or_zoom,
//         'Email': params.email,
//         'Zoom': params.zoom,
//         'Add Prescription': params.add_prescription,
//         'Lense': params.lens,
//         'Previously Visited Store': params.previously_visited_stores,
//         'Send Prescription Method': params.send_prescription,
//         'Color': pro_color
//       },
//     },
//     success: function(res){
//       window.location.href = "https://www.mottoptical.com/cart";
//     },
//     error: function(err){
//       console.log(err)
//     }
//   })
// }


$('.single-option-selector').change(function(){
  var color = $('#SingleOptionSelector-0 option:selected').val();
  var size = $('#SingleOptionSelector-1 option:selected').val();
  var variant = color+' / '+size;
  $('select[name=id] option:contains("'+variant+'")').prop('selected', true);

})

$('.remove-product').click(function(){
  var id = $(this).attr('data-id');
  var handle = $(this).attr('demo');
  if (handle.includes("handling"))
  {
    alert('you cannot remove handler without removing demo products')
    return false;
  }
  $.ajax({
    type: 'post',
    url: '/cart/update.js',
    dataType: 'json',
    async: false,
    data: 'updates['+id+']=0',
    success: function(resp) {
      removeHandler();
      location.reload();
    }
  });
})

function removeHandler ()
{
  var cart;
  $.ajax({
    type: "GET",
    url: '/cart.js',
    dataType: 'json',
    async: false,
    success: function(full_cart){
      cart = full_cart;
    },
    error: function(err){
      console.log('CART Not Fetched !!!',err.error());
    }
  });

  var demo_counter = 0;
  if (cart.item_count > 0)
  {
    for (var i=0; i<cart.item_count; i++)
    {
      if (cart.items[i].handle.includes("demo"))
      {
        demo_counter ++;
      }
    }
  }
  if (demo_counter == 0)
  {
    var handler_id = 32333043892326;
    $.ajax({
      type: 'post',
      url: '/cart/update.js',
      dataType: 'json',
      async: false,
      data: 'updates['+handler_id+']=0',
      success: function(resp) {
      }
    });
  }
  
}


// function redirectToApp() {
//   event.preventDefault();

//   if ($("input#page_agree").is(":checked") == false) {
//     event.preventDefault();
//     alert("Please Accept Terms & Condition");
//     event.stopPropagation();
//     return false;
//   }
//   var homeTryOn = false;
//   var cart ;
//   $.ajax({
//     type: "GET",
//     url: '/cart.js',
//     dataType: 'json',
//     async: false,
//     success: function(full_cart){
//       cart = full_cart;
//       var htoItems = cart.items.find(o =>  o.handle.includes('demo'))
//       if(htoItems != undefined){
//         homeTryOn = true;
//       }
//     },
//     error: function(err){
//       console.log('CART Not Fetched !!!',err.error());
//     }
//   });

//   if(homeTryOn == true){
//     var params = {
//       items: cart.items,
//       items_subtotal_price: cart.items_subtotal_price,
//       original_total_price: cart.original_total_price,
//       token: cart.token,
//       total_discount: cart.total_discount,
//       total_price: cart.total_price,
//       total_weight: cart.total_weight,
//       shop_url: "mottoptical.myshopify.com"
//     };

//     $.ajax({
//       type: 'POST',
//       url: 'https://app.mottoptical.com/mottoptical_checkout',
//       dataType: 'json',
//       data: params,
//       responseType:'application/json',
//       headers: {
//         'Access-Control-Allow-Origin':'*',
//       },
//       success: function(data){
//         console.log(data)
//         window.location.href = 'https://app.mottoptical.com/checkout/'+data.id.toString();
//       },
//       error: function(err){
//         console.log('ERROR!!!', err)
//       }
//     })

//   } else {
//     document.location.href = '/cart/checkout';
//   }


// }


function getOrder ()
{
  var id = $('.external-order-search-form .srch-field').val();
  if (id != undefined || id != '')
  {
    $.ajax({
      type: 'GET',
      url: 'https://app.mottoptical.com/search_external_order',
      responseType: 'json',
      data: {id: id},
      success: function(res){
        showStatus(res.search_result)
        console.log("asdfasdfsad", res)
      },
      error: function(err){
      }
    })
  }
}

function showStatus(search_result)
{
  if (search_result.length > 0)
  {
    $('.no-record-found').hide();
    $('.search-result-data').show();
    $('.statusboxtext').removeClass('active');
    for (var i=0; i<search_result.length; i++)
    {
      var temp = search_result[i].status;
      temp = temp.trim();
      var status = temp.replace(/\s/g,"-").replace(/\//g, '-').replace(/\(|\)/g, "");
      $('.'+status+'').addClass('active');
      $('.order-promised-date').text(search_result[i].promised_date);
      console.log(status);
    }
  }
  else
  {
    $('.no-record-found').show();
    $('.search-result-data').hide();
  }
}


$('.openmodale').click(function (e) {
  e.preventDefault();
  $('.modale.pdp-contact').addClass('opened');
});
$('.closemodale').click(function (e) {
  e.preventDefault();
  $('.modale.pdp-contact').removeClass('opened');
});